import * as React from 'react';

// Utils
// Constants
// Actions
// Models
// Interfaces
// Components
// Styles
import '../styles/ConfirmedBookingHeader.scss';
import classNames from 'classnames';

type Props = {
  title: string;
  date: string;
  image: string;
  headerBadge: React.ReactNode;
  fullImage?: boolean;
};

const ConfirmedBookingHeader: React.FC<Props> = (props) => {
  const { date, title, image, fullImage, headerBadge } = props;
  return (
    <div className="confirmed-booking-header">
      <div className={classNames('confirmed-booking-header-image', { 'is--full': fullImage })}>
        <img src={image} />
      </div>
      <div>
        <div className="confirmed-booking-header-title">{title}</div>
        <div className="confirmed-booking-header-date">{date}</div>
      </div>
      {headerBadge}
    </div>
  );
};

export default ConfirmedBookingHeader;
